import React, { SVGAttributes } from 'react'

interface IIconProps extends SVGAttributes<any> {
    width?: number | string
    height?: number | string
    fill?: string
    stroke?: string
    className?: string
    onClick?: () => void
}

const IconDashboard = ({ width = 24, height = 24, fill = '#555', stroke = 'unset', className = '' }: IIconProps) => (
    <svg
        width={width}
        height={height}
        fill={fill}
        className={className}
        stroke={stroke}
        xmlns='http://www.w3.org/2000/svg'
        viewBox='0 0 50 50'
    >
        <path d='M 45 2 C 43.894531 2 43 2.894531 43 4 C 43 4.292969 43.074219 4.5625 43.1875 4.8125 L 35.1875 16 C 35.125 15.996094 35.0625 16 35 16 C 34.601563 16 34.21875 16.109375 33.90625 16.3125 L 27 12.875 C 26.933594 11.828125 26.0625 11 25 11 C 23.894531 11 23 11.894531 23 13 C 23 13.105469 23.015625 13.210938 23.03125 13.3125 L 15.71875 19.125 C 15.496094 19.039063 15.253906 19 15 19 C 14 19 13.179688 19.730469 13.03125 20.6875 L 6.21875 23.4375 C 5.878906 23.171875 5.460938 23 5 23 C 3.894531 23 3 23.894531 3 25 C 3 26.105469 3.894531 27 5 27 C 6.007813 27 6.832031 26.253906 6.96875 25.28125 L 13.78125 22.5625 C 14.121094 22.828125 14.539063 23 15 23 C 16.105469 23 17 22.105469 17 21 C 17 20.894531 16.984375 20.789063 16.96875 20.6875 L 24.28125 14.875 C 24.503906 14.960938 24.746094 15 25 15 C 25.398438 15 25.78125 14.890625 26.09375 14.6875 L 33 18.125 C 33.066406 19.171875 33.9375 20 35 20 C 36.105469 20 37 19.105469 37 18 C 37 17.707031 36.925781 17.4375 36.8125 17.1875 L 44.8125 6 C 44.875 6.003906 44.9375 6 45 6 C 46.105469 6 47 5.105469 47 4 C 47 2.894531 46.105469 2 45 2 Z M 41 15 L 41 50 L 49 50 L 49 15 Z M 43 17 L 47 17 L 47 48 L 43 48 Z M 21 24 L 21 50 L 29 50 L 29 24 Z M 23 26 L 27 26 L 27 48 L 23 48 Z M 31 29 L 31 50 L 39 50 L 39 29 Z M 33 31 L 37 31 L 37 48 L 33 48 Z M 11 32 L 11 50 L 19 50 L 19 32 Z M 13 34 L 17 34 L 17 48 L 13 48 Z M 1 36 L 1 50 L 9 50 L 9 36 Z M 3 38 L 7 38 L 7 48 L 3 48 Z' />
    </svg>
)

const IconProfile = ({ width = 24, height = 24, fill = '#555', stroke = 'unset', className = '' }: IIconProps) => {
    return (
        <svg
            width={width}
            height={height}
            fill={fill}
            className={className}
            stroke={stroke}
            xmlns='http://www.w3.org/2000/svg'
            viewBox='0 0 50 50'
        >
            <path fill='none' stroke='#000' strokeMiterlimit='10' strokeWidth='2' d='M33 47H8V3h34v28.091' />
            <path d='M18.444 14.929c-.036-.397 0-.674 0-1.037.248-.119.655-.596.737-1.174 0 0 .429-.271.429-.724 0-.316-.105-.55-.19-.636.23-.692.624-2.808-.893-2.808-.163-.287-.573-.55-1.118-.55-2.18.04-2.364 1.73-1.939 3.359 0 0-.228.23-.216.554.022.612.429.806.429.806.078.569.581 1.079.761 1.174 0 .363.036.64 0 1.037-.431 1.159-3.31.833-3.444 3.07h8.889c-.134-2.237-3.013-1.911-3.445-3.071z' />
            <path
                fill='none'
                stroke='#000'
                strokeLinecap='round'
                strokeLinejoin='round'
                strokeMiterlimit='10'
                strokeWidth='2'
                d='M28 11h8m-8 5h8M14 26h14m-14 6h11m-11 6h14m5-12h3'
            />
            <path
                fill='none'
                stroke='#000'
                strokeMiterlimit='10'
                strokeWidth='2'
                d='M37 39h11m-11 5h11M36 34h13v15H36z'
            />
        </svg>
    )
}

const IconProfileView = ({ width = 24, height = 24, fill = '#555', stroke = 'unset', className = '' }: IIconProps) => {
    return (
        <svg
            width={width}
            height={height}
            fill={fill}
            className={className}
            stroke={stroke}
            xmlns='http://www.w3.org/2000/svg'
            viewBox='0 0 50 50'
        >
            <path d='M32.41 3H7v44h17.29c-.81-.71-1.5-1.4-2.06-2H9V5h22v10h10v16.09c.7.27 1.36.6 2 .96V13.59L32.41 3zM33 13V6.42L39.59 13H33zm3 37c-7.6 0-13.6-8.1-13.8-8.4l-.4-.6.4-.6c.2-.3 6.2-8.4 13.8-8.4s13.6 8.1 13.8 8.4l.4.6-.4.6c-.2.3-6.2 8.4-13.8 8.4zm-11.7-9c1.5 1.8 6.2 7 11.7 7s10.3-5.2 11.7-7c-1.4-1.8-6.2-7-11.7-7s-10.3 5.2-11.7 7zM36 47c-3.3 0-6-2.7-6-6s2.7-6 6-6 6 2.7 6 6-2.7 6-6 6zm0-10c-2.2 0-4 1.8-4 4s1.8 4 4 4 4-1.8 4-4-1.8-4-4-4zm-2 4c0 1.1.9 2 2 2s2-.9 2-2-.9-2-2-2-2 .9-2 2z' />
        </svg>
    )
}

const IconCase = ({ width = 24, height = 24, fill = '#555', stroke = 'unset', className = '' }: IIconProps) => {
    return (
        <svg
            width={width}
            height={height}
            fill={fill}
            className={className}
            stroke={stroke}
            xmlns='http://www.w3.org/2000/svg'
            viewBox='0 0 50 50'
        >
            <path
                fill='none'
                stroke='#000'
                strokeLinecap='round'
                strokeMiterlimit='10'
                strokeWidth='2'
                d='M47 10H3a2 2 0 00-2 2v32a2 2 0 002 2h44a2 2 0 002-2V12a2 2 0 00-2-2z'
            />
            <path
                fill='none'
                stroke='#000'
                strokeLinecap='round'
                strokeMiterlimit='10'
                strokeWidth='2'
                d='M1 27a2 2 0 002 2h44a2 2 0 002-2M32 9V6a2 2 0 00-2-2H20a2 2 0 00-2 2v3'
            />
            <path d='M25 22a2 2 0 100 4 2 2 0 100-4z' />
        </svg>
    )
}

const IconAlarm = ({ width = 24, height = 24, fill = '#555', stroke = 'unset', className = '' }: IIconProps) => {
    return (
        <svg
            width={width}
            height={height}
            fill={fill}
            className={className}
            stroke={stroke}
            xmlns='http://www.w3.org/2000/svg'
            viewBox='0 0 50 50'
        >
            <path
                fill='none'
                stroke='#000'
                strokeMiterlimit='10'
                strokeWidth='2'
                d='M23 11V9c0-1.1.9-2 2-2h0c1.1 0 2 .9 2 2v2'
            />
            <path
                fill='none'
                stroke='#000'
                strokeLinejoin='round'
                strokeMiterlimit='10'
                strokeWidth='2'
                d='M21.128 38c-.085.304-.128.63-.128 1 0 2.2 1.8 4 4 4s4-1.8 4-4c0-.367-.042-.693-.127-.995l-.002-.007'
            />
            <path
                fill='none'
                stroke='#000'
                strokeLinejoin='round'
                strokeMiterlimit='10'
                strokeWidth='2'
                d='M35 29v-7.8C35 15.219 30.981 11 25 11h0c-5.981 0-10 4.081-10 10.063v7.8c0 2.175-1.1 4.606-2.188 6.419L11 38h28l-1.813-2.719C36.1 33.469 35 31.175 35 29z'
            />
            <path
                fill='none'
                stroke='#000'
                strokeMiterlimit='10'
                strokeWidth='2'
                d='M41.333 31.333C42.933 28.667 44 25.467 44 22s-.933-6.533-2.667-9.333M45.667 34C47.8 30.533 49 26.4 49 22s-1.2-8.533-3.333-12m-37 21.333C7.067 28.667 6 25.467 6 22s.933-6.533 2.667-9.333M4.333 34C2.2 30.533 1 26.4 1 22s1.2-8.533 3.333-12'
            />
        </svg>
    )
}

const IconEdit = ({ width = 25, height = 25, className = '', ...rest }: IIconProps) => {
    return (
        <svg
            className={className}
            width={width}
            height={height}
            viewBox='0 0 32 32'
            version='1.1'
            xmlns='http://www.w3.org/2000/svg'
            xmlnsXlink='http://www.w3.org/1999/xlink'
            {...rest}
        >
            <defs>
                <filter id='filter-edit'>
                    <feColorMatrix
                        in='SourceGraphic'
                        type='matrix'
                        values='0 0 0 0 0.466667 0 0 0 0 0.466667 0 0 0 0 0.466667 0 0 0 1.000000 0'
                    />
                </filter>
            </defs>
            <g id='icons/action/icon-edit/size-m' stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
                <g filter='url(#filter-edit)' id='icons8-edit-(7)'>
                    <g transform='translate(6.000000, 6.000000)'>
                        <polyline
                            id='Path'
                            stroke='#000000'
                            strokeWidth='1.28'
                            strokeLinecap='round'
                            strokeLinejoin='round'
                            points='17.6322207 4.6486069 3.30548966 18.9748966 8.73477536e-13 19.862069 0.886731034 16.5565793 15.2134621 2.22984828'
                        />
                        <path
                            d='M18.8685241,4.03156499 C18.8663172,4.03332414 19.2322207,3.66742069 19.2322207,3.66742069 C20.0712828,2.82835862 20.0712828,1.46802759 19.2331034,0.629406897 C18.3931586,-0.210096552 17.033269,-0.209213793 16.1942069,0.629406897 C16.1942069,0.629406897 15.8278621,0.995751724 15.830059,0.993544828 L18.8685241,4.03156499 Z M0.967062069,16.4758069 L3.38626207,18.8950069 L0.209213793,19.6528552 L0.967062069,16.4758069 Z'
                            id='Shape'
                            fill='#000000'
                            fillRule='nonzero'
                        />
                    </g>
                </g>
            </g>
        </svg>
    )
}

const IconDelete = ({ width = 25, height = 25, className = '', stroke = '#bbb', onClick = () => {} }: IIconProps) => {
    return (
        <svg
            className={className}
            width={width}
            height={height}
            viewBox='0 0 32 32'
            version='1.1'
            xmlns='http://www.w3.org/2000/svg'
            xmlnsXlink='http://www.w3.org/1999/xlink'
            onClick={onClick}
            stroke={stroke}
            fill='none'
        >
            <g transform='translate(8.000000, 5.000000)'>
                <path
                    d='M5.28,2.4 L5.28,0.96 C5.28,0.432 5.712,0 6.24,0 L10.08,0 C10.608,0 11.04,0.432 11.04,0.96 L11.04,2.4 M0,2.4 L16.32,2.4 M8.16,5.76 L8.16,17.76 M11.04,5.76 L11.04,17.76 M5.28,5.76 L5.28,17.76'
                    id='Shape'
                    strokeWidth='0.96'
                />
                <path
                    d='M15.36,2.4 L15.36,20.16 C15.36,20.688 14.928,21.12 14.4,21.12 L1.92,21.12 C1.392,21.12 0.96,20.688 0.96,20.16 L0.96,2.4'
                    id='Path'
                    strokeWidth='0.96'
                />
            </g>
        </svg>
    )
}

const IconAdd = ({ width = 22, height = 22, className = '', fill = 'currentColor' }: IIconProps) => {
    return (
        <svg
            xmlns='http://www.w3.org/2000/svg'
            width={width}
            height={height}
            viewBox='0 0 50 50'
            className={className}
            style={{ fill: fill }}
        >
            <path d='M25 2C12.264 2 2 12.264 2 25s10.264 23 23 23 23-10.264 23-23S37.736 2 25 2zm0 2c11.664 0 21 9.336 21 21s-9.336 21-21 21S4 36.664 4 25 13.336 4 25 4zm-1 9v11H13v2h11v11h2V26h11v-2H26V13h-2z' />
        </svg>
    )
}

const IconAddBlue = ({ width = 22, height = 22, className = '' }: IIconProps) => {
    return <IconAdd width={width} height={height} className={className} fill='#005aff' />
}

const IconAddGrey = ({ width = 24, height = 24, className = '' }: IIconProps) => {
    return <IconAdd width={width} height={height} className={className} fill='#777' />
}

const IconAddWhite = ({ width = 24, height = 24, className = '' }: IIconProps) => {
    return <IconAdd width={width} height={height} className={className} fill='#fff' />
}

const IconDeleteWhite = ({ width = 20, height = 20, className = '' }: IIconProps) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox='0 0 24 24'
            version='1.1'
            xmlns='http://www.w3.org/2000/svg'
            xmlnsXlink='http://www.w3.org/1999/xlink'
        >
            <g id='icons/icon-forms/icon-remove-w' stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
                <circle id='Oval' stroke='#FFFFFF' cx='12' cy='12' r='7.5' />
                <g
                    id='Group-5'
                    transform='translate(9.000000, 9.000000)'
                    stroke='#FFFFFF'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                >
                    <g id='Group-4' transform='translate(3.000000, 0.000000)'>
                        <polyline
                            id='Stroke-718'
                            transform='translate(1.500000, 3.000000) scale(-1, 1) translate(-1.500000, -3.000000) '
                            points='0 0 3 3 0 6'
                        />
                    </g>
                    <g
                        id='Group-4'
                        transform='translate(1.500000, 3.000000) scale(-1, 1) translate(-1.500000, -3.000000) '
                    >
                        <polyline
                            id='Stroke-718'
                            transform='translate(1.500000, 3.000000) scale(-1, 1) translate(-1.500000, -3.000000) '
                            points='0 0 3 3 0 6'
                        />
                    </g>
                </g>
            </g>
        </svg>
    )
}

const IconCheck = ({ width = 20, height = 20, className = '' }: IIconProps) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox='0 0 24 24'
            version='1.1'
            xmlns='http://www.w3.org/2000/svg'
            xmlnsXlink='http://www.w3.org/1999/xlink'
        >
            <defs>
                <filter id='filter-3'>
                    <feColorMatrix
                        in='SourceGraphic'
                        type='matrix'
                        values='0 0 0 0 0.466667 0 0 0 0 0.466667 0 0 0 0 0.466667 0 0 0 1.000000 0'
                    />
                </filter>
            </defs>
            <g
                id='icons/icon-forms/icon-check'
                stroke='none'
                strokeWidth='1'
                fill='none'
                fillRule='evenodd'
                strokeLinecap='round'
                strokeLinejoin='round'
            >
                <g filter='url(#filter-3)' id='icons8-checkmark-(5)'>
                    <g transform='translate(5.000000, 6.000000)'>
                        <polyline
                            id='Path'
                            stroke='#000000'
                            strokeWidth='1.6'
                            points='0 7.7248 5.5684 12.5392 13.6 0.2608'
                        />
                    </g>
                </g>
            </g>
        </svg>
    )
}

const IconCheckBlue = ({ width = 20, height = 20, className = '' }: IIconProps) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox='0 0 24 24'
            version='1.1'
            xmlns='http://www.w3.org/2000/svg'
            xmlnsXlink='http://www.w3.org/1999/xlink'
        >
            <defs>
                <filter id='filter-2'>
                    <feColorMatrix
                        in='SourceGraphic'
                        type='matrix'
                        values='0 0 0 0 0.000000 0 0 0 0 0.725490 0 0 0 0 0.949020 0 0 0 1.000000 0'
                    />
                </filter>
            </defs>
            <g
                id='icons/icon-forms/icon-check-blue'
                stroke='none'
                strokeWidth='1'
                fill='none'
                fillRule='evenodd'
                strokeLinecap='round'
                strokeLinejoin='round'
            >
                <g filter='url(#filter-2)' id='icons8-checkmark-(5)'>
                    <g transform='translate(6.000000, 7.000000)'>
                        <polyline
                            id='Path'
                            stroke='#000000'
                            strokeWidth='1.6'
                            points='0 6.07896794 4.91329412 10 12 0'
                        />
                    </g>
                </g>
            </g>
        </svg>
    )
}

const IconCheckBlueCircle = ({ width = 18, height = 18, className = '' }: IIconProps) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox='0 0 50 50'
            version='1.1'
            xmlns='http://www.w3.org/2000/svg'
            fill='#005aff'
            className={className}
        >
            <path d='M 25 2 C 12.309534 2 2 12.309534 2 25 C 2 37.690466 12.309534 48 25 48 C 37.690466 48 48 37.690466 48 25 C 48 12.309534 37.690466 2 25 2 z M 25 4 C 36.609534 4 46 13.390466 46 25 C 46 36.609534 36.609534 46 25 46 C 13.390466 46 4 36.609534 4 25 C 4 13.390466 13.390466 4 25 4 z M 34.988281 14.988281 A 1.0001 1.0001 0 0 0 34.171875 15.439453 L 23.970703 30.476562 L 16.679688 23.710938 A 1.0001 1.0001 0 1 0 15.320312 25.177734 L 24.316406 33.525391 L 35.828125 16.560547 A 1.0001 1.0001 0 0 0 34.988281 14.988281 z' />
        </svg>
    )
}

const IconMove = ({ width = 20, height = 20, className = '' }: IIconProps) => {
    return (
        <svg xmlns='http://www.w3.org/2000/svg' width={width} height={height} viewBox='0 0 32 32' className={className}>
            <defs>
                <filter id='filter-10'>
                    <feColorMatrix
                        in='SourceGraphic'
                        values='0 0 0 0 0.466667 0 0 0 0 0.466667 0 0 0 0 0.466667 0 0 0 1.000000 0'
                    />
                </filter>
                <filter id='filter-20'>
                    <feColorMatrix
                        in='SourceGraphic'
                        values='0 0 0 0 0.333333 0 0 0 0 0.333333 0 0 0 0 0.333333 0 0 0 1.000000 0'
                    />
                </filter>
                <filter id='filter-30'>
                    <feColorMatrix
                        in='SourceGraphic'
                        values='0 0 0 0 0.333333 0 0 0 0 0.333333 0 0 0 0 0.333333 0 0 0 1.000000 0'
                    />
                </filter>
            </defs>
            <g fill='none' fillRule='evenodd' stroke='none' strokeWidth='1'>
                <g filter='url(#filter-10)'>
                    <g transform='translate(11 8)'>
                        <g filter='url(#filter-20)'>
                            <g stroke='#000'>
                                <path strokeWidth='2' d='M4 0.327L0 0.327' />
                                <path strokeWidth='2' d='M4 6.865L0 6.865' />
                                <path strokeWidth='2' d='M0 13.404L4 13.404' />
                                <path strokeWidth='3' d='M4 0.327L0 0.327' />
                                <path strokeWidth='3' d='M4 6.865L0 6.865' />
                                <path strokeWidth='3' d='M0 13.404L4 13.404' />
                            </g>
                        </g>
                        <g filter='url(#filter-30)'>
                            <g stroke='#000' transform='translate(6)'>
                                <path strokeWidth='2' d='M4 0.327L0 0.327' />
                                <path strokeWidth='2' d='M4 6.865L0 6.865' />
                                <path strokeWidth='2' d='M0 13.404L4 13.404' />
                                <path strokeWidth='3' d='M4 0.327L0 0.327' />
                                <path strokeWidth='3' d='M4 6.865L0 6.865' />
                                <path strokeWidth='3' d='M0 13.404L4 13.404' />
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    )
}

const IconX = ({ width = 20, height = 20, className = '' }: IIconProps) => {
    return (
        <svg xmlns='http://www.w3.org/2000/svg' width={width} height={height} viewBox='0 0 50 50' className={className}>
            <path fill='none' stroke='#000' strokeMiterlimit='10' strokeWidth='2' d='M7 7l36 36m0-36L7 43' />
        </svg>
    )
}

const IconDown = ({ width = 20, height = 20, className = '', onClick = () => {} }: IIconProps) => {
    return (
        <svg
            xmlns='http://www.w3.org/2000/svg'
            width={width}
            height={height}
            className={className}
            viewBox='0 0 32 32'
            onClick={onClick}
        >
            <g
                fill='none'
                fillRule='evenodd'
                stroke='none'
                strokeLinecap='round'
                strokeLinejoin='round'
                strokeWidth='1'
            >
                <path stroke='#555' d='M11 6L21 16 11 26' transform='rotate(90 16 16)' />
            </g>
        </svg>
    )
}

const IconUp = ({ width = 20, height = 20, className = '' }: IIconProps) => {
    return (
        <svg xmlns='http://www.w3.org/2000/svg' width={width} height={height} className={className} viewBox='0 0 32 32'>
            <g
                fill='none'
                fillRule='evenodd'
                stroke='none'
                strokeLinecap='round'
                strokeLinejoin='round'
                strokeWidth='1'
            >
                <path stroke='#777' strokeWidth='1.5' d='M11 6L21 16 11 26' transform='matrix(0 -1 -1 0 32 32)' />
            </g>
        </svg>
    )
}

const IconArrowDown = ({ width = 32, height = 32, className = '', fill = '#555555', onClick = () => {} }: IIconProps) => {
    return (
        <svg width={width} height={height} className={className} viewBox='0 0 32 32' onClick={onClick}>
            <g
                id='icons/nav/icon-arrow-down/size-m'
                stroke='none'
                strokeWidth='1'
                fill='none'
                fillRule='evenodd'
                strokeLinecap='round'
                strokeLinejoin='round'
            >
                <polyline
                    id='Stroke-718'
                    stroke={fill}
                    transform='translate(16.000000, 16.000000) rotate(90.000000) translate(-16.000000, -16.000000) '
                    points='11 6 21 16 11 26'
                />
            </g>
        </svg>
    )
}

const IconArrowUp = ({ width = 32, height = 32, className = '', onClick = () => {} }: IIconProps) => {
    return (
        <svg width={width} height={height} className={className} viewBox='0 0 32 32' onClick={onClick}>
            <g
                id='icons/nav/icon-arrow-up/size-m'
                stroke='none'
                strokeWidth='1'
                fill='none'
                fillRule='evenodd'
                strokeLinecap='round'
                strokeLinejoin='round'
            >
                <polyline
                    id='Stroke-718'
                    stroke='#777777'
                    strokeWidth='1.5'
                    transform='translate(16.000000, 16.000000) scale(1, -1) rotate(90.000000) translate(-16.000000, -16.000000) '
                    points='11 6 21 16 11 26'
                />
            </g>
        </svg>
    )
}

const IconUserPlaceholder = ({ width = 30, height = 30, className = '', onClick = () => {} }: IIconProps) => {
    return (
        <svg
            xmlns='http://www.w3.org/2000/svg'
            width={width}
            height={height}
            className={className}
            onClick={onClick}
            viewBox='0 0 30 30'
        >
            <path d='M15 3a6 6 0 00-6 6v1a6 6 0 1012 0V9a6 6 0 00-6-6zm-.002 16c-4.006 0-9.146 2.167-10.625 4.09C3.459 24.279 4.329 26 5.828 26H24.17c1.499 0 2.369-1.721 1.455-2.91C24.146 21.168 19.004 19 14.998 19z' />
        </svg>
    )
}

const IconUpdate = ({ width = 20, height = 20, className = '', onClick = () => {} }: IIconProps) => {
    return (
        <svg
            xmlns='http://www.w3.org/2000/svg'
            width={width}
            height={height}
            className={className}
            onClick={onClick}
            viewBox='0 0 50 50'
        >
            <path d='M43.125 2a4.857 4.857 0 00-3.438 1.438l-.812.812 6.875 6.875.813-.813a4.858 4.858 0 000-6.874A4.864 4.864 0 0043.124 2zm-5.781 4.031a1.005 1.005 0 00-.594.313L4.312 38.812a1.02 1.02 0 00-.28.438l-2 7.5a.997.997 0 00.261.957c.25.25.613.352.957.262l7.5-2a1.02 1.02 0 00.438-.282L43.656 13.25a1.006 1.006 0 00-1.406-1.438L9.969 44.094 5.906 40.03 38.188 7.75a1 1 0 00-.75-1.719h-.094z' />
        </svg>
    )
}

const IconTrash = ({ width = 20, height = 20, className = '', onClick = () => {} }: IIconProps) => {
    return (
        <svg
            xmlns='http://www.w3.org/2000/svg'
            width={width}
            height={height}
            className={className}
            onClick={onClick}
            viewBox='0 0 50 50'
        >
            <path d='M21 2c-1.645 0-3 1.355-3 3v2h-7.846a1 1 0 00-.17-.014A1 1 0 009.84 7H8a1 1 0 100 2h1v36c0 1.645 1.355 3 3 3h26c1.645 0 3-1.355 3-3V9h1a1 1 0 100-2h-1.832a1 1 0 00-.326 0H32V5c0-1.645-1.355-3-3-3h-8zm0 2h8c.555 0 1 .445 1 1v2H20V5c0-.555.445-1 1-1zM11 9h7.832a1 1 0 00.326 0h11.674a1 1 0 00.326 0H39v36c0 .555-.445 1-1 1H12c-.555 0-1-.445-1-1V9zm7.984 4.986A1 1 0 0018 15v25a1 1 0 102 0V15a1 1 0 00-1.016-1.014zm6 0A1 1 0 0024 15v25a1 1 0 102 0V15a1 1 0 00-1.016-1.014zm6 0A1 1 0 0030 15v25a1 1 0 102 0V15a1 1 0 00-1.016-1.014z' />
        </svg>
    )
}

const IconBackArrow = ({ width = 20, height = 20, className = '', onClick = () => {} }: IIconProps) => {
    return (
        <svg
            xmlns='http://www.w3.org/2000/svg'
            width={width}
            height={height}
            className={className}
            onClick={onClick}
            viewBox='0 0 50 50'
        >
            <path d='M19.938 12.969a1.999 1.999 0 00-1.375.625l-9.875 10L7.312 25l1.375 1.406 9.876 10a2.011 2.011 0 002.875-2.812L14.905 27H40a1.988 1.988 0 001.754-.992 1.982 1.982 0 000-2.016A1.988 1.988 0 0040 23H14.906l6.531-6.594a2.001 2.001 0 00-1.5-3.437z' />
        </svg>
    )
}

const IconArrowDownCircle = ({
    width = 20,
    height = 20,
    className = '',
    onClick = () => {},
    stroke = '#999'
}: IIconProps) => {
    return (
        <svg
            xmlns='http://www.w3.org/2000/svg'
            viewBox='0 0 50 50'
            width={width}
            height={height}
            className={className}
            onClick={onClick}
        >
            <path
                fill='none'
                fillRule='evenodd'
                stroke={stroke}
                strokeLinecap='round'
                strokeLinejoin='round'
                strokeMiterlimit='10'
                strokeWidth='2'
                d='M25 3A22 22 0 1 0 25 47A22 22 0 1 0 25 3Z'
                clipRule='evenodd'
            />
            <path
                fill='none'
                fillRule='evenodd'
                stroke={stroke}
                strokeLinecap='round'
                strokeLinejoin='round'
                strokeMiterlimit='10'
                strokeWidth='2'
                d='M35 22L25 32 15 22'
                clipRule='evenodd'
            />
        </svg>
    )
}

const TrailingIcon = ({ width = 16, height = 16, className = '', fill = '#005AFF', onClick = () => {} }: IIconProps) => {
    return (
        <svg width={width} height={height} className={className} viewBox="0 0 16 16" fill="none" onClick={onClick}>
            <g id="Trailing Icon">
                <path
                    id="Vector"
                    d="M13.4422 4.66714C13.2985 4.67054 13.1619 4.7306 13.0623 4.83422L7.99882 9.89769L2.93535 4.83422C2.88457 4.78203 2.82385 4.74054 2.75676 4.71221C2.68968 4.68388 2.6176 4.66928 2.54478 4.66927C2.43639 4.6693 2.33047 4.70165 2.24056 4.7622C2.15065 4.82274 2.08084 4.90872 2.04005 5.00915C1.99926 5.10957 1.98935 5.21988 2.01159 5.32597C2.03382 5.43206 2.08719 5.52911 2.16486 5.60471L7.61358 11.0534C7.71577 11.1556 7.85434 11.2129 7.99882 11.2129C8.14331 11.2129 8.28188 11.1556 8.38406 11.0534L13.8328 5.60471C13.9119 5.52861 13.9662 5.43039 13.9886 5.32292C14.0109 5.21544 14.0003 5.10371 13.9581 5.00237C13.9159 4.90103 13.844 4.81481 13.752 4.75499C13.6599 4.69517 13.552 4.66455 13.4422 4.66714Z"
                    fill={fill}
                />
            </g>
        </svg>
    )
}

export {
    IconDashboard,
    IconProfile,
    IconProfileView,
    IconCase,
    IconAlarm,
    IconEdit,
    IconDelete,
    IconDeleteWhite,
    IconAdd,
    IconAddBlue,
    IconAddGrey,
    IconAddWhite,
    IconCheck,
    IconCheckBlue,
    IconCheckBlueCircle,
    IconMove,
    IconX,
    IconDown,
    IconUp,
    IconArrowDown,
    IconArrowUp,
    IconArrowDownCircle,
    IconUserPlaceholder,
    IconUpdate,
    IconTrash,
    IconBackArrow,
    TrailingIcon
}
